<script lang="ts" setup>
    import { onMounted, ref, reactive, computed } from 'vue';
    import ChoiceTable from "../../components/ChoiceTable.vue";
    import ActionButton from "../../components/ActionButton.vue"; 
    import MessageSection from '../../components/Messages/MessageSection.vue'
    import ModalDialog from "../../components/ModalDialog.vue"
    import { ICol, RenderModeType } from "../../lib/ChoiceTableHelpers";
    import { schedule } from '../../lib/ChoiceApi';
    import { MessageSectionType, DisplayStyle, ModalSize } from "../../Enums/UiEnums";
    import { IPatientMultipleCheckInItem, IPatientMultipleCheckInResults, IPatientMultipleCheckInInputItem, IPatientMultipleCheckInInputs } from '../../lib/Models/ScheduleModel';

    const pageHeight = ref<number>(0);

    const formData = reactive<{
        saving: boolean,
        actionMessage: string,
        tableData: IPatientMultipleCheckInItem[]
    }>({
        saving: false,
        actionMessage: "",
        tableData: []
    });

    const tableColumns = ref<ICol[]>([
        { Name: '', DataField:"selected", RenderMode: RenderModeType.Selection },
        { Name: 'Time', DataField: 'appointmentTime' },
        { Name: 'Status', DataField: 'appointmentStatus' },
        { Name: 'Resource', DataField: 'resourceName' },
        { Name: 'Location', DataField: 'locationName' },
    ]);

    const props = defineProps<{
        appointmentId: number
        appointmentResults: IPatientMultipleCheckInResults,
        saveEnabled: number,
        pageTitle: string
    }>();

    onMounted(async () => {
        formData.tableData = props.appointmentResults.appointmentList;
        pageHeight.value = 768;
        //if (document.body.parentElement != null)
            //pageHeight.value = Math.floor(document.body.parentElement.clientHeight * 0.25);
    });

    const tableStyle = computed<string>(() => `font-size: 0.75rem; overflow-y: scroll; height: 150px`);
    const checkInEnabled = computed<boolean>(() => props.saveEnabled == 1 && !formData.saving);

    async function CheckInItems() {
        formData.actionMessage = "";
        const filterList = formData.tableData.filter(o => o.selected);
        if (filterList.length <= 0) {
            formData.actionMessage = "Please select item(s) to check-in.";
            return;
        }

        let appointmentList: IPatientMultipleCheckInInputItem[] = [];

        filterList.forEach( (element) => {
            appointmentList.push({appointmentId: element.appointmentId});
        }); 

        const post_data = <IPatientMultipleCheckInInputs> {
            launchAppointmentId: props.appointmentId,
            appointmentList: appointmentList
        };
        formData.saving = true;
        const resp = await schedule.PatientMultipleCheckInSave(post_data);
        formData.saving = false;
        if (!resp.passed) {
            formData.actionMessage = resp.message ?? "An error occured updating the status of one of the selected items.";
            return;
        }
        CloseDialog();
    }

    const emit=defineEmits(["close-vue-modal-iframe"]);  

    function CloseDialog() : void {  
        emit('close-vue-modal-iframe',"");
    } 
</script>

<template>
    <ModalDialog :size=ModalSize.Large :show="true" :closeOnClickOutside="false" @hidden="CloseDialog">
        <template v-slot:title>{{props.pageTitle}}</template>
        <div class="row mt-2">
            <div class="col">
                <p :style="tableStyle">
                    <ChoiceTable 
                        ref="multiCheckInTable"
                        :columns="tableColumns" 
                        :data="formData.tableData" 
                        :show-filters="false" 
                        :allowSorting="true"
                        :key-value-data-member="'Col3Val'">Search
                    </ChoiceTable>
                </p>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-auto">
                <ActionButton
                    baseText = "Check-In"
                    spinText = "Checking-In"
                    :executing="formData.saving"    
                    :disabled="!checkInEnabled"   
                    :clickEvent="CheckInItems" 
                    :toolTip="'Check-In the selected item(s)'"
                    :width="135"
                    :executeInit="false">
                </ActionButton> 
            </div>
            <div class="col">
                <MessageSection v-if="formData.actionMessage" :show-icon="false" :type="MessageSectionType.Text" :display-style="DisplayStyle.Danger">
                    {{formData.actionMessage}}
                </MessageSection>    
            </div>
        </div>
    </ModalDialog>
</template>

